import React, { Component } from "react";
import styled from "styled-components";
import backgroundKaleidoTl from "assets/image/dsp_background_tl.png";
import backgroundKaleidoTp from "assets/image/dsp_background_tp.png";
import backgroundKaleidoDt from "assets/image/dsp_background_dt.png";
import backgroundKaleidoMb from "assets/image/dsp_background_mb.png";
import { envConfig } from "env-config";
import { connect } from "react-redux";
import { languageActions } from "actions/languageAction";
import PropTypes from "prop-types";

const mapStateToProps = state => {
    return {
        selectedLang: state.languageSession.selectedLang,
        showBackgroundImg: state.backgroundOptions.showBackgroundImg
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateLanguage: lang => dispatch(languageActions.updateLanguage(lang))
    };
};

class AppBackgroundKaleido extends Component {
    static propTypes = {
        selectedLang: PropTypes.string,
        showBackgroundImg: PropTypes.bool,
        storeThis: PropTypes.func
    };
    constructor(props) {
        super(props);

        this.state = {
            bgImg: ""
        };

        if (props.storeThis) {
            props.storeThis("APP", this);
        }
    }

    handleResize = () => {
        const windowWidth = parseInt(window.innerWidth);
        let bgImg = "";
        if (windowWidth > 1019 && windowWidth < 1440) {
            bgImg = backgroundKaleidoTl;
        } else if (windowWidth > 449 && windowWidth < 1020) {
            bgImg = backgroundKaleidoTp;
        } else if (windowWidth < 450) {
            bgImg = backgroundKaleidoMb;
        } else if (windowWidth > 1439) {
            bgImg = backgroundKaleidoDt;
        }
        this.setState({ bgImg });
        return bgImg;
    };

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    }

    render() {
        return (
            this.props.showBackgroundImg && (
                <BackgroundKaleido selectedLang={this.props.selectedLang}>
                    <div className="kaleido">
                        <div className="img-box">
                            <img
                                src={this.state.bgImg}
                                className="img-bg"
                                alt="background-img"
                            />
                        </div>
                    </div>
                </BackgroundKaleido>
            )
        );
    }
}

const BackgroundKaleido = styled.div`
    // height: 100%;
    .kaleido {
        height: 100%;
        width: 50%;
        position: absolute;
        right: 0;
        top: 0;
        text-align: right;

        .img-box {
            position: relative;
            max-height: 100%;
            overflow: auto;
        }

        .img-bg {
            width: 100%;
            max-height: 100%;
        }
    }
`;

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AppBackgroundKaleido);
